import script from "./AulasAvulsasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AulasAvulsasModal.vue?vue&type=script&setup=true&lang=js"

import "./AulasAvulsasModal.vue?vue&type=style&index=0&id=8df09b76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8df09b76"]])

export default __exports__